import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Box, Tab, Tabs } from "@mui/material";
import InsurerMake from "./make";
import InsurerModel from "./model";
import InsurerVariantList from "./variant";

export const InsurerMMVList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const tabValue = sessionStorage.getItem("insurerMMVTab") || "make";
  const tabValues = ["make", "model", "variant"];

  const [value, setValue] = useState(tabValue);

  // Extract tabState from URL query
  const getTabFromQuery = () => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get("tabState");
    return tabParam === null ? "make" : tabParam;
  };

  useEffect(() => {
    setValue(getTabFromQuery());
  }, [location.search]);

  const handleTabChange = (_, newValue) => {
    setValue(newValue);
    sessionStorage.setItem("insurerMMVTab", newValue);
    navigate(`?tabState=${newValue}`);
  };

  const renderComponent = () => {
    switch (value) {
      case "make":
        return <InsurerMake tabState={value}/>;
      case "model":
        return <InsurerModel tabState={value}/>;
      case "variant":
        return <InsurerVariantList tabState={value}/>;

      default:
        return null;
    }
  };

  return (
    <DashboardLayout>
      <Box sx={{ marginX: 1 }}>
        <Tabs
          value={value}
          onChange={handleTabChange}
          textColor="primary"
          indicatorColor="secondary"
          aria-label="secondary tabs example"
        >
          {/* Render tabs based on tabValues */}
          {tabValues.map((tabValue) => (
            <Tab
              key={tabValue}
              value={tabValue}
              label={`Insurer ${
                tabValue.charAt(0).toUpperCase() + tabValue.slice(1)
              }`}
              sx={{ fontWeight: value === tabValue ? "bold" : "normal" }}
            />
          ))}
        </Tabs>
      </Box>

      <Box>{renderComponent()}</Box>
    </DashboardLayout>
  );
};
